export type NullOrUndefined = null | undefined;

export type AnyNonNullable = NonNullable<unknown>;

export type Nullable<T = unknown> = NonNullable<T> | NullOrUndefined;

export function isNullOrUndefined(value: unknown): value is NullOrUndefined {
  return typeof value === 'undefined' || value === null;
}

export function isNotNullOrUndefined<T>(
  value: T | NullOrUndefined
): value is T {
  return !isNullOrUndefined(value);
}
